/* Maison Store — product page behavior: size guide dialog, reviews, sticky add to cart, offer note */
(function () {
  if (window.__maisonPdp) return;
  window.__maisonPdp = true;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mz-sg-open]');
    if (open) {
      var dialog = open.parentElement.querySelector('dialog');
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }
    var close = e.target.closest('[data-mz-sg-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.mz-sg__dialog')) e.target.close();
  });

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function reviews() {
    document.querySelectorAll('[data-mz-reviews]').forEach(function (root) {
      var all = (window.MAISON_REVIEWS || {})[root.dataset.handle] || [];
      var per = parseInt(root.dataset.perPage, 10) || 6;
      var shown = 0;
      var list = root.querySelector('[data-mz-reviews-list]');
      var more = root.querySelector('[data-mz-reviews-more]');
      var empty = root.querySelector('[data-mz-reviews-empty]');
      var summary = root.querySelector('[data-mz-reviews-summary]');
      var source = root.dataset.sourceLabel;

      function add() {
        all.slice(shown, shown + per).forEach(function (r) {
          var li = el('li', 'mz-review');
          var stars = el('div', 'mz-review__stars', '★★★★★'.slice(0, r[1]) + '☆☆☆☆☆'.slice(0, 5 - r[1]));
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', r[1] + ' out of 5 stars');
          li.appendChild(stars);
          li.appendChild(el('p', 'mz-review__text', r[4]));
          var meta = el('div', 'mz-review__meta');
          meta.appendChild(el('span', 'mz-review__name', r[0]));
          var date = new Date(r[2] + 'T12:00:00');
          if (!isNaN(date)) meta.appendChild(el('span', '', date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })));
          if (r[3]) meta.appendChild(el('span', '', r[3]));
          if (source) meta.appendChild(el('span', 'mz-review__src', source));
          li.appendChild(meta);
          list.appendChild(li);
        });
        shown = Math.min(all.length, shown + per);
        if (more) more.hidden = shown >= all.length;
      }

      if (all.length) {
        if (empty) empty.hidden = true;
        if (summary) {
          var avg = all.reduce(function (a, r) { return a + r[1]; }, 0) / all.length;
          summary.textContent = avg.toFixed(1) + ' out of 5 · ' + all.length + (all.length === 1 ? ' review' : ' reviews') + (root.dataset.summarySuffix ? ' ' + root.dataset.summarySuffix : '');
          summary.hidden = false;
        }
        add();
      }
      if (more) more.addEventListener('click', add);

      var form = root.querySelector('[data-mz-reviews-form]');
      var write = root.querySelector('[data-mz-reviews-write]');
      if (form && write) {
        write.setAttribute('aria-expanded', String(!form.hidden));
        write.addEventListener('click', function () {
          form.hidden = !form.hidden;
          write.setAttribute('aria-expanded', String(!form.hidden));
          if (!form.hidden) {
            var first = form.querySelector('input[type="text"]');
            if (first) first.focus();
          }
        });
      }
    });
  }

  function sticky() {
    var bar = document.querySelector('.mz-sticky');
    var btn = document.querySelector('.product-form__submit');
    if (!bar || !btn) return;
    var stickyBtn = bar.querySelector('[data-mz-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-mz-sticky-price]');

    function sync() {
      var price = document.querySelector('.product__info-container .price');
      if (price && stickyPrice) stickyPrice.innerHTML = price.innerHTML;
      var label = btn.querySelector('span');
      stickyBtn.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      stickyBtn.textContent = (label ? label.textContent : btn.textContent).trim();
    }
    function set(on) {
      bar.classList.toggle('is-on', on);
      bar.inert = !on;
    }

    sync();
    set(false);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) setTimeout(sync, 900);
    });
    stickyBtn.addEventListener('click', function () { btn.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        set(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(btn);
    }
  }

  function promo() {
    document.querySelectorAll('.mz-promo').forEach(function (note) {
      var key = 'mz-promo-' + (note.dataset.key || 'offer');
      var close = note.querySelector('[data-mz-promo-close]');
      if (window.Shopify && Shopify.designMode) {
        note.classList.add('is-on');
      } else {
        try { if (sessionStorage.getItem(key)) return; } catch (e) {}
        setTimeout(function () { note.classList.add('is-on'); }, (parseFloat(note.dataset.delay) || 4) * 1000);
      }
      if (close) close.addEventListener('click', function () {
        note.classList.remove('is-on');
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    });
  }

  function init() { reviews(); sticky(); promo(); }
       var started = false;
     function start() { if (started) return; started = true; init(); }
     if (document.readyState === 'complete') start();
     else { document.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();